import { OFFER_STATUS } from "./constants";

export function getOfferDashboardType(offer, statuses) {
  if (offer?.estado_id === OFFER_STATUS.APROBADA) return "approved";
  const status = statuses.find((item) => item.id === offer?.estado_id);
  const description = status?.descripcion?.trim().toLowerCase() || "";
  return description === "denegada" || description === "cancelada"
    ? "rejected"
    : "pending";
}

export function indexOfferStatusHistory(history) {
  const latest = new Map();
  (history || []).forEach((movement) => {
    const key = `${movement.oferta_id}:${movement.revision_num}`;
    const previous = latest.get(key);
    if (!previous || new Date(movement.fecha_estado) > new Date(previous.fecha_estado)) {
      latest.set(key, movement);
    }
  });
  return latest;
}

export function getLatestOfferStatusMovement(offer, statusHistory) {
  const movement = statusHistory instanceof Map
    ? statusHistory.get(`${offer.id}:${offer.revision_num}`)
    : (statusHistory || [])
      .filter((item) => item.oferta_id === offer.id && Number(item.revision_num) === Number(offer.revision_num))
      .sort((first, second) => new Date(second.fecha_estado) - new Date(first.fecha_estado))[0];
  return {
    estado_id: movement?.estado_id ?? offer.estado_id,
    fecha: new Date(movement?.fecha_estado ?? offer.fecha_alta),
    importe: Number(movement?.importe_pvp_final ?? offer.calc_total_pvp_final ?? offer.calc_total_pvp ?? 0) || 0,
  };
}
